// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    AccountsByCaseSearchRequestModel,
    CancelWorkflowRequestModel,
    GatewayError,
    GetCasesRequestModel,
    GetWorkflowsRequestModel,
    ISiteRegistrationRequestModel,
    PatientsSearchPatientsRequestModel,
    SearchAccountsRequestModel,
    SearchCasesRequestModel,
    SearchWorkflowsRequestModel,
    SiteAccountGetAccountGetAccountRequestModel,
    SiteAccountGetCaseGetCaseRequestModel,
    SiteAccountGetPartySiteAccountGetPartyDefaultResponse,
    SiteAccountRequestModel,
    SiteAccountSearchCasesSiteAccountSearchCasesDefaultResponse,
    SiteAccountSiteAccountCancelWorkflowDefaultResponse,
    SiteAccountSiteAccountGetAccountDefaultResponse,
    SiteAccountSiteAccountGetCaseDefaultResponse,
    SiteAccountSiteAccountGetCasesDefaultResponse,
    SiteAccountSiteAccountGetSiteAccountDefaultResponse,
    SiteAccountSiteAccountGetWorkflowsDefaultResponse,
    SiteAccountSiteAccountSearchAccountsDefaultResponse,
    SiteAccountSiteAccountSearchWorkflowsDefaultResponse,
    SiteAccountSiteAccountSiteRegistrationDefaultResponse,
    SiteAccountV2PatientsSearchPatientsResponse,
    SiteAccountV2SiteAccountCreateSiteAccountResponse,
    SiteAccountV2SiteAccountObject,
    SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse,
    SiteAccountsAlternateRequestModel,
    SiteAccountsRequestModel,
    TrialcardPrescriberV3ModelsPrescriberSearchRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeSiteAccountApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param patientsSearchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientsSearchAllProgramPatients (patientsSearchPatientsRequestModel: PatientsSearchPatientsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2PatientsSearchPatientsResponse>> {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchAllProgramPatients';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientsSearchPatientsRequestModel' is not null or undefined
        if (patientsSearchPatientsRequestModel === null || patientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchPatientsRequestModel was null or undefined when calling patientsSearchAllProgramPatients.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2PatientsSearchPatientsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     * 
     * @param accountsByCaseSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientsSearchPatientAccountsByCaseSearch (accountsByCaseSearchRequestModel: AccountsByCaseSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2PatientsSearchPatientsResponse>> {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByCaseSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountsByCaseSearchRequestModel' is not null or undefined
        if (accountsByCaseSearchRequestModel === null || accountsByCaseSearchRequestModel === undefined) {
            throw new Error('Required parameter accountsByCaseSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByCaseSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(accountsByCaseSearchRequestModel, "AccountsByCaseSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2PatientsSearchPatientsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     * 
     * @param trialcardPrescriberV3ModelsPrescriberSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientsSearchPatientAccountsByPrescriber (trialcardPrescriberV3ModelsPrescriberSearchRequestModel: TrialcardPrescriberV3ModelsPrescriberSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2PatientsSearchPatientsResponse>> {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByPrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'trialcardPrescriberV3ModelsPrescriberSearchRequestModel' is not null or undefined
        if (trialcardPrescriberV3ModelsPrescriberSearchRequestModel === null || trialcardPrescriberV3ModelsPrescriberSearchRequestModel === undefined) {
            throw new Error('Required parameter trialcardPrescriberV3ModelsPrescriberSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByPrescriber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(trialcardPrescriberV3ModelsPrescriberSearchRequestModel, "TrialcardPrescriberV3ModelsPrescriberSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2PatientsSearchPatientsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientsSearchPatientsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientsSearchPatients (patientsSearchPatientsRequestModel: PatientsSearchPatientsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2PatientsSearchPatientsResponse>> {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatients';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientsSearchPatientsRequestModel' is not null or undefined
        if (patientsSearchPatientsRequestModel === null || patientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter patientsSearchPatientsRequestModel was null or undefined when calling patientsSearchPatients.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2PatientsSearchPatientsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     * 
     * @param cancelWorkflowRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountCancelWorkflow (cancelWorkflowRequestModel: CancelWorkflowRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountCancelWorkflowDefaultResponse>> {
        const _url_ = '/edge/siteAccount/CancelWorkflow';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'cancelWorkflowRequestModel' is not null or undefined
        if (cancelWorkflowRequestModel === null || cancelWorkflowRequestModel === undefined) {
            throw new Error('Required parameter cancelWorkflowRequestModel was null or undefined when calling siteAccountCancelWorkflow.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(cancelWorkflowRequestModel, "CancelWorkflowRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountCancelWorkflowDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountCancelWorkflowDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param siteAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountCreateSiteAccount (siteAccountRequestModel: SiteAccountRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2SiteAccountCreateSiteAccountResponse>> {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/createSiteAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteAccountRequestModel' is not null or undefined
        if (siteAccountRequestModel === null || siteAccountRequestModel === undefined) {
            throw new Error('Required parameter siteAccountRequestModel was null or undefined when calling siteAccountCreateSiteAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountRequestModel, "SiteAccountRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2SiteAccountCreateSiteAccountResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountCreateSiteAccountResponse");
        }
        return response;
    }
    /**
     * 
     * @param siteAccountGetAccountGetAccountRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetAccount (siteAccountGetAccountGetAccountRequestModel: SiteAccountGetAccountGetAccountRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountGetAccountDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteAccountGetAccountGetAccountRequestModel' is not null or undefined
        if (siteAccountGetAccountGetAccountRequestModel === null || siteAccountGetAccountGetAccountRequestModel === undefined) {
            throw new Error('Required parameter siteAccountGetAccountGetAccountRequestModel was null or undefined when calling siteAccountGetAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountGetAccountGetAccountRequestModel, "SiteAccountGetAccountGetAccountRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountGetAccountDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountGetAccountDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param siteAccountGetCaseGetCaseRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetCase (siteAccountGetCaseGetCaseRequestModel: SiteAccountGetCaseGetCaseRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountGetCaseDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetCase';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteAccountGetCaseGetCaseRequestModel' is not null or undefined
        if (siteAccountGetCaseGetCaseRequestModel === null || siteAccountGetCaseGetCaseRequestModel === undefined) {
            throw new Error('Required parameter siteAccountGetCaseGetCaseRequestModel was null or undefined when calling siteAccountGetCase.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountGetCaseGetCaseRequestModel, "SiteAccountGetCaseGetCaseRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountGetCaseDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getCasesRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetCases (getCasesRequestModel: GetCasesRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountGetCasesDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetCases';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getCasesRequestModel' is not null or undefined
        if (getCasesRequestModel === null || getCasesRequestModel === undefined) {
            throw new Error('Required parameter getCasesRequestModel was null or undefined when calling siteAccountGetCases.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getCasesRequestModel, "GetCasesRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountGetCasesDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountGetCasesDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetParty (body: object, xProgramId?: string): Promise<AxiosResponse<SiteAccountGetPartySiteAccountGetPartyDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetParty';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetParty.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountGetPartySiteAccountGetPartyDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetPartySiteAccountGetPartyDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetSiteAccount (body: object, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountGetSiteAccountDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetSiteAccount';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetSiteAccount.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountGetSiteAccountDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountGetSiteAccountDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param getWorkflowsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountGetWorkflows (getWorkflowsRequestModel: GetWorkflowsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountGetWorkflowsDefaultResponse>> {
        const _url_ = '/edge/siteAccount/GetWorkflows';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'getWorkflowsRequestModel' is not null or undefined
        if (getWorkflowsRequestModel === null || getWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter getWorkflowsRequestModel was null or undefined when calling siteAccountGetWorkflows.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getWorkflowsRequestModel, "GetWorkflowsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountGetWorkflowsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountGetWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param searchAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSearchAccounts (searchAccountsRequestModel: SearchAccountsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountSearchAccountsDefaultResponse>> {
        const _url_ = '/edge/siteAccount/SearchAccounts';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'searchAccountsRequestModel' is not null or undefined
        if (searchAccountsRequestModel === null || searchAccountsRequestModel === undefined) {
            throw new Error('Required parameter searchAccountsRequestModel was null or undefined when calling siteAccountSearchAccounts.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchAccountsRequestModel, "SearchAccountsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountSearchAccountsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountSearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param searchCasesRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSearchCases (searchCasesRequestModel: SearchCasesRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSearchCasesSiteAccountSearchCasesDefaultResponse>> {
        const _url_ = '/edge/siteAccount/SearchCases';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'searchCasesRequestModel' is not null or undefined
        if (searchCasesRequestModel === null || searchCasesRequestModel === undefined) {
            throw new Error('Required parameter searchCasesRequestModel was null or undefined when calling siteAccountSearchCases.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchCasesRequestModel, "SearchCasesRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSearchCasesSiteAccountSearchCasesDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchCasesSiteAccountSearchCasesDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param searchWorkflowsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSearchWorkflows (searchWorkflowsRequestModel: SearchWorkflowsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountSearchWorkflowsDefaultResponse>> {
        const _url_ = '/edge/siteAccount/SearchWorkflows';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'searchWorkflowsRequestModel' is not null or undefined
        if (searchWorkflowsRequestModel === null || searchWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter searchWorkflowsRequestModel was null or undefined when calling siteAccountSearchWorkflows.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(searchWorkflowsRequestModel, "SearchWorkflowsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountSearchWorkflowsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountSearchWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param siteAccountsRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSiteAccountsByPortalId (siteAccountsRequestModel: SiteAccountsRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse>> {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteAccountsRequestModel' is not null or undefined
        if (siteAccountsRequestModel === null || siteAccountsRequestModel === undefined) {
            throw new Error('Required parameter siteAccountsRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountsRequestModel, "SiteAccountsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountSiteAccountsByPortalIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param siteAccountsAlternateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSiteAccountsByPortalIdAlternate (siteAccountsAlternateRequestModel: SiteAccountsAlternateRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountV2SiteAccountObject>> {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalIdAlternate';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteAccountsAlternateRequestModel' is not null or undefined
        if (siteAccountsAlternateRequestModel === null || siteAccountsAlternateRequestModel === undefined) {
            throw new Error('Required parameter siteAccountsAlternateRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalIdAlternate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteAccountsAlternateRequestModel, "SiteAccountsAlternateRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountV2SiteAccountObject>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountObject");
        }
        return response;
    }
    /**
     * 
     * @param iSiteRegistrationRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteAccountSiteRegistration (iSiteRegistrationRequestModel: ISiteRegistrationRequestModel, xProgramId?: string): Promise<AxiosResponse<SiteAccountSiteAccountSiteRegistrationDefaultResponse>> {
        const _url_ = '/edge/siteAccount/SiteRegistration';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iSiteRegistrationRequestModel' is not null or undefined
        if (iSiteRegistrationRequestModel === null || iSiteRegistrationRequestModel === undefined) {
            throw new Error('Required parameter iSiteRegistrationRequestModel was null or undefined when calling siteAccountSiteRegistration.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iSiteRegistrationRequestModel, "ISiteRegistrationRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteAccountSiteAccountSiteRegistrationDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteAccountSiteRegistrationDefaultResponse");
        }
        return response;
    }
}
